var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeBarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.000000000000004,
    height: 24.000000000000004,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_12",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 5.390429,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_13",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 6.45207,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_14",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 7.479464,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_15",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 8.575352,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_16",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 9.602746,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_17",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 0.082224,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_18",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 1.212358,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_19",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 2.273999,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_20",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 3.33564,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_21",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 4.363034,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_27",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 10.698634,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_28",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 11.726028,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_29",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 12.753423,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_30",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 13.780817,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_31",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 14.808212,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_32",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 15.835606,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_33",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 16.863001,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_34",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 17.993135,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_35",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 19.123269,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_36",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 20.287649,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_37",
    height: 6.609571,
    width: 0.136986,
    y: -0.005533,
    x: 21.520522,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_38",
    height: 4,
    width: 0.136986,
    y: -0.005533,
    x: 22.684903,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_68",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 5.390429,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_69",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 6.486316,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_70",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 7.513711,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_71",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 8.609598,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_72",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 9.636993,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_73",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 0.082224,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_74",
    height: 4,
    width: 0.136986,
    y: 20.02866,
    x: 1.143865,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_75",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 2.239752,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_76",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 3.33564,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_77",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 4.363034,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_78",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 10.73288,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_79",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 11.760275,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_80",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 12.787669,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_81",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 13.815064,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_82",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 14.842458,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_83",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 15.869853,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_84",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 16.897247,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_85",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 18.027381,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_86",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 19.157515,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_87",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 20.321895,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_88",
    height: 7,
    width: 0.136986,
    y: 17.014969,
    x: 21.554769,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_89",
    height: 4,
    width: 0.136986,
    y: 19.994413,
    x: 22.719149,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#7f7f7f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBarIcon);
export default __webpack_public_path__ + "static/media/time-bar-icon.5566459694219f8753fb8e5a9c57b2d1.svg";
export { ForwardRef as ReactComponent };